import React, { CSSProperties, useMemo } from "react";
import Table from "./Table";
import { useSelector } from "react-redux";
import { getPrizeRank } from "../store/userBuyInLogsSlice";
import AnimationNumber from "./AnimationNumber";

function PoolRewards() {
  const prizeRank = useSelector(getPrizeRank);

  const cols = useMemo(() => {
    return [
      {
        key: "name",
        col: 4,
        format: (val: string | number) => (
          <div className="d-flex gap-2 align-items-center">
            <div>{val}</div>
          </div>
        ),
      },
      {
        key: "prize",
        col: 7,
        className: "justify-content-end px-3",
        format: (val: string | number) => <AnimationNumber value={val ?? 0} />,
      },
    ];
  }, []);
  const groups = useMemo(() => {
    return prizeRank.prizeRank;
  }, [prizeRank.prizeRank]);

  const poolAmount = useMemo(
    () => prizeRank.totalReward ?? 0,
    [prizeRank.totalReward]
  );

  return (
    <div className="position-relative">
      <div id="group-table" className="row pb-4 position-relative">
        <div className="col d-flex align-items-center justify-content-center position-relative">
          <img
            alt="pool-light"
            src="/assets/rewards-light.png?v=1"
            className="position-absolute start-50 translate-middle-x"
            style={{ width: "120%", bottom: 0 }}
          />
          <img
            alt="coin"
            src="/assets/coin1.png"
            className="animate-floating position-absolute"
            width={120}
            style={{ top: "45%", right: "10%", rotate: "65deg" }}
          />
          <img
            alt="coin"
            src="/assets/coin1.png"
            className="animate-floating position-absolute"
            width={64}
            style={
              {
                top: "5%",
                left: "23%",
                rotate: "45deg",
                "--animation-delay": "1s",
                "--animation-duration": "4s",
              } as CSSProperties
            }
          />
          <img
            alt="coin"
            src="/assets/coin2.png"
            className="animate-floating position-absolute"
            width={90}
            style={
              {
                top: "10%",
                right: "20%",
                "--animation-delay": "1.5s",
                "--animation-duration": "4.5s",
              } as CSSProperties
            }
          />
          <img
            alt="pool"
            src="/assets/pool-rewards.png?v=1"
            className="position-absolute start-50 top-50 translate-middle"
            style={{ height: "90%" }}
          />
          <img
            alt="coin"
            src="/assets/coin1.png"
            className="animate-floating position-absolute"
            width={90}
            style={
              {
                top: "32%",
                left: "23%",
                "--animation-delay": "1s",
              } as CSSProperties
            }
          />
          <div className="pool-rewards">
            <span>
              <AnimationNumber value={poolAmount} />
            </span>
          </div>
        </div>
        <div className="col" style={{ fontSize: "2.75rem" }}>
          <div className="position-relative text-center mb-2">
            <img
              alt="coin"
              src="/assets/coin1.png"
              className="animate-floating position-absolute"
              width={48}
              style={
                {
                  top: "40%",
                  left: "13%",
                  "--animation-delay": "0s",
                  "--animation-duration": "5s",
                } as CSSProperties
              }
            />
            <img
              alt="coin"
              src="/assets/coin2.png"
              className="animate-floating position-absolute"
              width={80}
              style={
                {
                  top: "-15%",
                  right: "13%",
                  rotate: "60deg",
                  "--animation-delay": "1s",
                  "--animation-duration": "4.5s",
                } as CSSProperties
              }
            />
            <img
              src="/assets/prize-frame.png"
              alt="prize-frame"
              style={{ height: "72px" }}
            />
            <div
              className="position-absolute start-50 top-50 translate-middle fw-bold"
              style={{ fontSize: "2.25rem" }}
            >
              TOTAL PRIZE
            </div>
          </div>
          <Table
            // header={group.name}
            items={groups}
            cols={cols}
            // titles={titles}
          />
        </div>
        <div>
          <img
            alt="coin"
            src="/assets/coin2.png"
            className="animate-floating position-absolute"
            width={90}
            style={
              {
                bottom: "-10%",
                left: "46%",
                rotate: "20deg",
                "--animation-delay": "0.5s",
                "--animation-duration": "3s",
              } as CSSProperties
            }
          />
        </div>
      </div>
    </div>
  );
}

export default PoolRewards;
